<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="add"
                            :loading="dataForm.addLoading" v-if="page.isNew">Salvar</v-btn>
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark @click="update"
                            :loading="dataForm.updateLoading" v-if="!page.isNew">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/alunos">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Nome" v-model="dataset.data.name" required
                                                :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Email (opcional)" v-model="dataset.data.email"
                                                :rules="[$rules.email]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>


                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Matricula" v-model="dataset.data.registration"
                                                required :rules="[$rules.required]" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Telefone" v-model="dataset.data.phone_number"
                                                v-mask="$masks.phone" outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-file-input dense accept="image/png, image/jpeg"
                                                prepend-icon="" outlined counter :rules="[$rules.fileSize(2)]"
                                                hint="O arquivo não pode ser superior a 2MB" hide-details="auto"
                                                label="Imagem facial (opcional)" :clearable="true" @change="onFileSelected($event)"
                                                ref="file">
                                            </v-file-input>

                                            <v-img v-if="dataset.data.document_url"
                                                @click="openDoc(dataset.data.document_url)" class="rounded-xl"
                                                :height="100" :width="100" :src="dataset.data.document_url">
                                            </v-img>

                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row v-if="!page.isNew && exitPreference && (!exitPreference.responsible_enabled || !exitPreference.transporter_enabled)">
                <v-col cols="12">
                    <v-alert type="warning" outlined class="student-exit-alert">
                        <div class="student-exit-alert__content">
                            <div>
                                <strong>{{ exitPreferenceLabel }}</strong>
                                <span>Esta configuração deve ser considerada antes de qualquer liberação manual.</span>
                                <small v-if="exitPreference.disabled_at">
                                    Alterado em {{ $moment(exitPreference.disabled_at).format("DD/MM/YYYY [às] HH:mm") }}
                                </small>
                            </div>
                            <v-chip small label>{{ exitPreference.change_source || "configuração da escola" }}</v-chip>
                        </div>
                    </v-alert>
                </v-col>
            </v-row>

            <v-row v-if="page.isNew">
                <v-col>
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Matrícula inicial</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-select no-data-text="Nenhuma turma encontrada" dense
                                        :items="dataset.classes" label="Turma (opcional)"
                                        v-model="dataset.data.class_id" item-value="id" item-text="name" outlined
                                        clearable hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row v-if="!page.isNew">
                <v-col>
                    <v-card class="card-form-outlined student-movements-card">
                        <v-row align="center">
                            <v-col>
                                <v-card-title class="card-group-title">Movimentações</v-card-title>
                                <v-card-subtitle>Últimos registros de entrada e saída do aluno</v-card-subtitle>
                            </v-col>
                            <v-col cols="auto">
                                <v-chip label small :color="movementStatus.color" :text-color="movementStatus.textColor">
                                    {{ movementStatus.label }}
                                </v-chip>
                            </v-col>
                        </v-row>

                        <v-data-table
                            class="app-table student-movements-table"
                            :headers="dataset.movementHeaders"
                            :items="dataset.movements"
                            :loading="dataset.movementsLoading"
                            hide-default-footer
                            no-data-text="Nenhuma movimentação registrada"
                            loading-text="Carregando movimentações..."
                        >
                            <template v-slot:[`item.code`]="{ item }">
                                <v-chip label small :color="movementCodeColor(item.code)" text-color="white">
                                    {{ movementCodeLabel(item.code) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ formatMovementDate(item.created_at) }}
                            </template>

                            <template v-slot:[`item.equipment`]="{ item }">
                                <div class="movement-equipment">
                                    <strong>{{ item.equipment_name || "Equipamento não identificado" }}</strong>
                                    <small>{{ item.equipment_ip || item.device_id || "-" }}</small>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col>
                    <v-card class="card-form-outlined">
                        <v-row align="center">
                            <v-col>
                                <v-card-title class="card-group-title">Endereço</v-card-title>
                            </v-col>
                        </v-row>

                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="CEP" v-model="dataset.data.address_postal_code" required
                                        :rules="[$rules.required]" v-mask="$masks.zipCode" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" @click="loadZipcodeData()">Buscar</v-btn>
                                        </template>
                                        <span>Buscar endereço</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="10">
                                    <v-text-field dense label="Rua" v-model="dataset.data.address_street" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-text-field dense label="Número" v-model="dataset.data.address_number" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Bairro" v-model="dataset.data.address_district" required
                                        :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field disabled readonly dense label="Cidade"
                                        v-model="dataset.data.address_city" required :rules="[$rules.required]" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="2">
                                    <v-select disabled readonly no-data-text="Nenhuma UF encontrada" dense
                                        :items="dataset.states" label="UF" v-model="dataset.data.address_state"
                                        item-value="acronym" item-text="acronym" outlined :rules="[$rules.required]"
                                        required hide-details="auto">
                                    </v-select>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

        </v-form>


        <v-row>
            <v-col>
                <v-card class="card-form-outlined">

                    <v-row align="center">
                        <v-col>
                            <v-card-title class="card-group-title">{{ answerableTitle }}</v-card-title>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="dataset.answerables && dataset.answerables.length > 0">
                        <v-row>
                            <v-col cols="6" v-for="(item, index) in dataset.answerables" :key="index">
                                <v-list-item class="list-item-outlined">
                                    <v-list-item-avatar>
                                        <v-icon size="32">mdi-human-male-boy</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-subtitle> {{ item.name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-tooltip bottom>
                                            <template #activator="{ on }">
                                                <v-icon v-on="on" @click="removeAnswerable(item)"
                                                    size="large">mdi-delete-outline</v-icon>
                                            </template>
                                            <span>Remover responsável</span>
                                        </v-tooltip>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-col>

                        </v-row>

                    </v-card-text>

                    <v-card-text v-else>
                        <span>Nenhum responsável associado</span>
                    </v-card-text>

                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn v-on="on" @click="openAnswerableSelectionModal(dataset.answerables)"
                                            color="primary" dark elevation="2" small>
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Adicionar responsável</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>


        <v-dialog v-model="dialogViewDoc" max-width="60%">
            <v-card>
                <v-img :src="selectedDoc" alt="" contain />
            </v-card>
        </v-dialog>

        <answerable-selection-modal ref="AnswerableSelectionModalRef"></answerable-selection-modal>

    </v-container>
</template>

<script>

import string from "@/common/util/string"

import axios from "axios"
import states from "@/common/data/states.data"

import { eventHub } from "@/main";

import AnswerableSelectionModal from "@/layouts/components/AnswerableSelectionModal.vue"

export default {
    name: "StudentDetails",
    components: {
        'answerable-selection-modal': AnswerableSelectionModal,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            states: states,
            classes: [],
            data: {
            },
            answerables: [],
            movements: [],
            movementsLoading: false,
            movementSummary: null,
            movementHeaders: [
                { text: "Movimento", value: "code" },
                { text: "Data/Hora", value: "created_at" },
                { text: "Equipamento", value: "equipment" },
            ],
            exitPreference: null,
        },
        selectedDoc: null,
        dialogViewDoc: false,
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },

    }),

    created() {
        this.loadData();

        eventHub.$on('DIALOG-ASWERABLE-SELECTION', value => {
            this.dialogAsnwerableSelection = value;
        });
    },

    computed: {
        answerableTitle() {
            if (!this.dataset.data || !this.dataset.data.answerables || this.dataset.data.answerables.length === 1) {
                return "Responsável";
            } else {
                return "Responsáveis";
            }
        },

        movementStatus() {
            if (!this.dataset.movementSummary || !this.dataset.movementSummary.last_movement_at) {
                return { label: "Sem movimentação", color: "grey lighten-3", textColor: "dark" };
            }

            if (this.dataset.movementSummary.current_status === "inside") {
                return { label: "Na escola", color: "success", textColor: "white" };
            }

            return { label: "Fora da escola", color: "grey lighten-3", textColor: "dark" };
        },

        exitPreference() {
            return this.dataset.exitPreference;
        },

        exitPreferenceLabel() {
            if (!this.exitPreference) return "CHEGUEI ativo";
            if (!this.exitPreference.responsible_enabled && !this.exitPreference.transporter_enabled) {
                return "Liberação por responsáveis e transporte desabilitada";
            }
            if (!this.exitPreference.transporter_enabled) return "Liberação via transporte escolar desabilitada";
            return "Liberação pelo responsável desabilitada";
        },
    },

    methods: {
        goBack() {
            this.$router.replace("/alunos");
        },

        openDoc(cover) {
            this.selectedDoc = cover;
            this.dialogViewDoc = true;
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();
            await this.loadClasses();
            await this.load();
            await this.loadExitPreference();
            await this.loadMovements();
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `${this.page.isNew ? 'Novo aluno' : 'Detalhes do aluno'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Alunos",
                disabled: false,
                to: "/alunos",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.title,
                disabled: true,
                exact: true,
            });
        },

        async openAnswerableSelectionModal(item) {

            this.$refs.AnswerableSelectionModalRef.setData(item);

            this.$refs.AnswerableSelectionModalRef.open().then((results) => {

                if (results.length > 0) {
                    results.forEach(result => {
                        const exists = this.dataset.answerables.some(answerable => answerable.id === result.id);
                        if (!exists) {
                            this.dataset.answerables.push(result);
                        }
                    });
                }
            });

        },

        async load() {

            if (this.page.isNew) return;

            try {
                const result = await axios.get(`/api/v1/students/${this.$route.params.id}`);

                const data = result.data.content;

                this.dataset.data = {
                    ...data,
                    class_id: data.enrollment ? data.enrollment.class_id : data.class_id,
                    enrollment_status: data.enrollment ? data.enrollment.status : null,
                };

                this.dataset.answerables = data.answerables

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadMovements() {
            if (this.page.isNew) return;

            this.dataset.movementsLoading = true;

            try {
                const result = await axios.get(`/api/v1/students/${this.$route.params.id}/movements`, {
                    params: { limit: 10 }
                });

                this.dataset.movements = result.data.content.data || [];
                this.dataset.movementSummary = result.data.content.summary || null;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.movementsLoading = false;
            }
        },

        async loadExitPreference() {
            if (this.page.isNew) return;
            try {
                const result = await axios.get(`/api/v1/school-exit/students/${this.$route.params.id}/preference`);
                this.dataset.exitPreference = result.data.content || null;
            } catch (error) {
                this.dataset.exitPreference = null;
            }
        },

        movementCodeLabel(code) {
            const normalizedCode = Number(code);

            if (normalizedCode === 1001) return "Entrada";
            if (normalizedCode === 1002) return "Saída";

            return "Evento";
        },

        movementCodeColor(code) {
            return Number(code) === 1001 ? "success" : "primary";
        },

        formatMovementDate(value) {
            if (!value) return "-";

            return this.$moment(value).format("DD/MM/YYYY HH:mm");
        },

        async loadClasses() {

            try {
                const result = await axios.get(`/api/v1/classes`, { params: { start: 1, limit: 100000, search: {} } });

                this.dataset.classes = result.data.content.data;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },



        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir o aluno?',
                title: 'Incluir aluno',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.addLoading = true;

            const payload = this.buildPayload();

            try {
                await axios.post('/api/v1/students', payload);

                this.$dialog.notify.info("Aluno adicionado com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar dados do aluno?',
                title: 'Atualizar aluno',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataForm.updateLoading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/students/${this.$route.params.id}`, payload);

                this.$dialog.notify.info("Dados do aluno atualizados com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.updateLoading = false;
            }
        },

        onFileSelected(file) {
            this.dataset.data.file = file;
        },


        // buildPayload() {
        //     const data = {
        //         name: this.dataset.data.name,
        //         email: this.dataset.data.email,
        //         registration: this.dataset.data.registration,
        //         phone_number: this.dataset.data.phone_number,
        //         address_street: this.dataset.data.address_street,
        //         address_number: this.dataset.data.address_number,
        //         address_district: this.dataset.data.address_district,
        //         address_postal_code: this.dataset.data.address_postal_code,
        //         address_state: this.dataset.data.address_state,
        //         address_city: this.dataset.data.address_city,
        //         class_id: this.dataset.data.class_id,
        //         answerables: this.dataset.answerables.map(answerable => answerable.id)

        //     }

        //     return data;

        // },

        buildPayload() {
            const formData = new FormData()

            if (this.dataset.data.name)
                formData.append('name', this.dataset.data.name);

            if (this.dataset.data.email)
                formData.append('email', this.dataset.data.email);

            if (this.dataset.data.registration)
                formData.append('registration', string.sanitizeCpfCnpj(this.dataset.data.registration));

            if (this.dataset.data.phone_number)
                formData.append('phone_number', this.dataset.data.phone_number);

            if (this.dataset.data.device_uuid)
                formData.append('device_uuid', this.dataset.data.device_uuid);

            if (this.dataset.data.address_street)
                formData.append('address_street', this.dataset.data.address_street);

            if (this.dataset.data.address_number)
                formData.append('address_number', this.dataset.data.address_number);

            if (this.dataset.data.address_district)
                formData.append('address_district', this.dataset.data.address_district);

            if (this.dataset.data.address_postal_code)
                formData.append('address_postal_code', this.dataset.data.address_postal_code);

            if (this.dataset.data.address_state)
                formData.append('address_state', this.dataset.data.address_state);

            if (this.dataset.data.address_city)
                formData.append('address_city', this.dataset.data.address_city);

            if (this.dataset.data.user_id)
                formData.append('user_id', this.dataset.data.user_id);

            if (this.dataset.data.class_id)
                formData.append('class_id', this.dataset.data.class_id);

            // if (this.dataset.data.description)
            //     formData.append('description', this.dataset.data.description);

            if (this.dataset.data.file)
                formData.append('document', this.dataset.data.file)

            for (let index = 0; index < this.dataset.answerables.length; index++) {
                formData.append(`answerables[${index}]`, this.dataset.answerables[index].id)
            }

            return formData;
        },

        async removeAnswerable(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Remover Responsável',
                actions: {
                    false: 'Cancelar',
                    true: 'Remover'
                }
            })

            if (!proceedAction) return;

            const student_id = this.dataset.data.id
            const answerable_id = item.id

            console.log("Student: ", student_id, "Answerable: ", item.id)

            try {

                const response = await axios.delete(`/api/v1/students/association/${student_id}`, {

                    data: {
                        answerable_id: answerable_id
                    }
                })

                this.dataset.answerables = this.dataset.answerables.filter(item => item.id !== answerable_id)

                this.$dialog.notify.info("Responsável removido com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },


        async loadZipcodeData() {

            if (!this.dataset.data.address_postal_code) {

                this.$dialog.notify.error("O campo CEP deve ser preenchido!", { position: "top-right", timeout: 3000 });

                return

            }

            const zipcode = string.sanitizeZipcode(this.dataset.data.address_postal_code)

            try {
                const result = await axios.get(`/api/v1/address/${zipcode}`);

                const resultData = result.data.content;

                const state = this.dataset.states.find((x) => x.acronym == resultData.state) || null

                const data = {
                    address_street: resultData.street,
                    address_district: resultData.district,
                    address_state: state ? state.acronym : null,
                    address_city: resultData.city
                }

                this.dataset.data = { ...this.dataset.data, ...data }

            } catch (error) {
                console.log(error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

    },

};
</script>

<style scoped>
.student-exit-alert__content { align-items: center; display: flex; gap: 16px; justify-content: space-between; }
.student-exit-alert__content strong, .student-exit-alert__content span, .student-exit-alert__content small { display: block; }
.student-exit-alert__content span { margin-top: 4px; }
.student-exit-alert__content small { margin-top: 6px; opacity: .8; }
@media (max-width: 600px) { .student-exit-alert__content { align-items: flex-start; flex-direction: column; } }
</style>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.list-item-outlined {
    border: 1px solid var(--v-gray-base) !important;
}

.student-movements-card {
    padding-bottom: 8px;
}

.student-movements-card .v-card__subtitle {
    color: #64748b;
    font-size: 13px;
    padding-top: 0;
}

.student-movements-table {
    border-top: 1px solid #eef2f7;
}

.movement-equipment {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.movement-equipment strong {
    color: #17233f;
    font-size: 13px;
    font-weight: 700;
}

.movement-equipment small {
    color: #64748b;
    font-size: 12px;
}
</style>
